import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import {FeedbackTriggerType} from 'records/FeedbackTrigger';
import FileUploadSharingDialogFormSharingTargets from 'components/pure/sharing/direct-share/dialog/FileUploadSharingDialogFormSharingTargets';
import UserStore from 'stores/UserStore';
import withRecipients from 'components/triggers/rule-context/WithRecipients';
import TriggerIconButton from 'components/triggers/TriggerIconButton';
import {List} from 'immutable';
import './SharesContext.styl';
import UserActions from 'actions/UserActions';
import {SmartAlertContextTitle} from 'components/triggers/rule-context/SmartAlertContextTitle';
import {ShareIcon} from '@components/icon/ShareIcon';
import {CogIcon} from '@components/icon/CogIcon';
import {CircleXIcon} from '@components/icon/CircleXIcon';

class SharesContext extends React.Component {
  constructor(props) {
    super(props);

    this.updateSharingTargets = this.updateSharingTargets.bind(this);
    this.withUserClick = this.withUserClick.bind(this);
    this.removeWithUsers = this.removeWithUsers.bind(this);
    this.state = {
      withUsers: false,
      userContextSelected: false,
    };
  }

  static getStores() {
    return [UserStore];
  }

  static getPropsFromStores(nextProps) {
    const {context} = nextProps;
    const sharesContext = context.matchAll.find(item => item.type === FeedbackTriggerType.SHARES);
    if (!sharesContext || sharesContext.matching.size === 0) {
      return {
        matchedUsers: [],
      };
    }

    const users = UserStore.getState().users;
    const selectedUsers = sharesContext.matching.map(emailOrId => {
      const foundUser = users.get(emailOrId);
      if (foundUser) {
        return {
          label: foundUser.getFullName(),
          value: foundUser.id,
        };
      } else {
        // it's an email for external share
        return {
          label: emailOrId,
          value: emailOrId,
        };
      }
    });

    return {
      matchedUsers: selectedUsers.toArray(),
    };
  }

  withUserClick() {
    this.setState({
      withUsers: true,
    });
  }

  removeWithUsers() {
    this.setState({
      withUsers: false,
    });
    this.updateSharingTargets(List([]));
  }

  updateSharingTargets(values) {
    const users = UserStore.getState().users;
    const emails = values.map(emailOrId => {
      const foundUser = users.get(emailOrId);
      if (foundUser) {
        return foundUser.id;
      } else {
        return emailOrId;
      }
    });
    const newContext = this.props.context.setIn(
      ['matchAll', this.getSharesIndex(), 'matching'],
      emails
    );
    this.props.contextChange(newContext);
  }

  getShares() {
    return this.props.context.matchAll.find(item => item.type === FeedbackTriggerType.SHARES);
  }

  getSharesIndex() {
    const shares = this.getShares();
    return this.props.context.matchAll.indexOf(shares);
  }

  componentDidMount() {
    UserActions.fetchAll.defer();
  }

  render() {
    const {matchedUsers} = this.props;
    const {withUsers} = this.state;
    const {usersEmpty, renderEmbeddedContent, showContextButton} = this.props;
    const viewButton = !withUsers && matchedUsers.length === 0;
    const showContext = showContextButton && !viewButton;
    const showButton = showContextButton && viewButton;
    const narrow = usersEmpty && matchedUsers.length === 0 && !withUsers;
    return (
      <div ref={c => (this.scrollDiv = c)} className="context-container">
        <SmartAlertContextTitle icon={ShareIcon} onClose={this.props.removeContext}>
          <span>they share the call</span>
        </SmartAlertContextTitle>
        <div className={narrow && 'initial-options'}>
          {renderEmbeddedContent()}
          {showButton && (
            <TriggerIconButton
              label={'Optional: Specify recipient'}
              onClick={this.withUserClick}
              icon={<CogIcon tooltip="Edit" />}
            />
          )}
          {showContext && (
            <div className="feedback-rule-type-select feedback-option">
              <div className="rule-context">
                <div className="rule-option-list">
                  <ul>
                    <li>
                      <div className="rule-label">with&nbsp;</div>
                      <div className="shares-context">
                        <FileUploadSharingDialogFormSharingTargets
                          tabIndex="1"
                          className="text-input"
                          name="sharingTargets"
                          sharingValues={matchedUsers}
                          error={null}
                          onDataChanged={() => null}
                          scrollDiv={() => this.scrollDiv}
                          updateSharingTargets={this.updateSharingTargets}
                          checkExternalShares={false}
                        />
                      </div>
                      <div className="delete" onClick={this.removeWithUsers}>
                        <CircleXIcon tooltip="Remove" />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withRecipients(connectToStores(SharesContext));
